export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      {/* Navigation */}
      <nav className="relative z-20 px-8 py-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/38c39dcc-c691-4204-bf72-e3062829be07.png" 
              alt="KENZAI d.o.o. Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className="text-white text-xl font-semibold tracking-tight">KENZAI d.o.o.</span>
          </div>
          <div className="flex items-center gap-8">
            <a href="#home" className="text-white/90 hover:text-white transition-colors text-sm font-medium cursor-pointer">Home</a>
            <a href="#products" className="text-white/90 hover:text-white transition-colors text-sm font-medium cursor-pointer">Products</a>
            <a href="#about" className="text-white/90 hover:text-white transition-colors text-sm font-medium cursor-pointer">About</a>
            <a href="#contact" className="text-white/90 hover:text-white transition-colors text-sm font-medium cursor-pointer">Contact</a>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-8 pt-20 pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-7xl font-bold text-white leading-tight">
                Premium iOS<br />
                <span className="text-6xl">Applications for</span><br />
                <span className="text-8xl bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent">Modern Users</span>
              </h1>
            </div>
            <p className="text-xl text-white/70 leading-relaxed max-w-xl">
              A team of experts developing cutting-edge applications for the iOS platform, designed to enhance user experience and improve mobile device security.
            </p>
          </div>

          {/* Right Content - iPhone Mockup */}
          <div className="relative flex justify-center lg:justify-end">
            <div className="relative w-80 h-[600px]">
              {/* iPhone Frame */}
              <div className="absolute inset-0 bg-gradient-to-br from-slate-700 to-slate-900 rounded-[3rem] shadow-2xl p-3">
                <div className="w-full h-full bg-slate-950 rounded-[2.5rem] overflow-hidden relative">
                  {/* Notch */}
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-6 bg-slate-950 rounded-b-3xl z-10"></div>
                  
                  {/* Screen Content - VPN App */}
                  <div className="w-full h-full bg-gradient-to-br from-teal-500 to-cyan-600 p-6 flex flex-col items-center justify-center">
                    <div className="w-32 h-32 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mb-6 shadow-lg">
                      <i className="ri-shield-check-line text-6xl text-white"></i>
                    </div>
                    <h3 className="text-white text-2xl font-bold mb-2">VPN Protected</h3>
                    <p className="text-white/80 text-sm mb-8">Your connection is secure</p>
                    <div className="w-full bg-white/10 backdrop-blur-sm rounded-2xl p-4 space-y-3">
                      <div className="flex justify-between items-center">
                        <span className="text-white/70 text-xs">Status</span>
                        <span className="text-white text-xs font-semibold">Connected</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-white/70 text-xs">Location</span>
                        <span className="text-white text-xs font-semibold">United States</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-white/70 text-xs">Speed</span>
                        <span className="text-white text-xs font-semibold">125 Mbps</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-teal-500/30 to-cyan-500/30 rounded-[3rem] blur-3xl -z-10"></div>
            </div>
          </div>
        </div>

        {/* Bottom Tagline */}
        <div className="absolute bottom-16 left-0 right-0 text-center">
          <h2 className="text-5xl font-bold text-white/40">Enhancing Security & Performance</h2>
        </div>
      </div>
    </section>
  );
}